/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Filters_ToInputs */

const es_admin_traces_filters_to = /** @type {(inputs: Admin_Traces_Filters_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasta`)
};

const en_admin_traces_filters_to = /** @type {(inputs: Admin_Traces_Filters_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

/**
* | output |
* | --- |
* | "To" |
*
* @param {Admin_Traces_Filters_ToInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_filters_to = /** @type {((inputs?: Admin_Traces_Filters_ToInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Filters_ToInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_filters_to(inputs)
	return en_admin_traces_filters_to(inputs)
});
export { admin_traces_filters_to as "admin.traces.filters.to" }